
export default [
        {
            title: "Dashboard",
            url: "/dashboard",
            icon: "icon-home",
            has_sub_menu: false,
            permission:"dashboard"
        },
        
        // {
        //     title: "Forms",
        //     url: "forms",
        //     icon: "icon-user-check",
        //     has_sub_menu: true,
        //     open: false,
        //     permission:"forms-view",

        //     sub_menus: [
        //         {
        //             title: "FRM EC16C (Annual)",
        //             url: "annual",
        //             icon: null,
        //             has_sub_menu: true,
        //             open: false,
        //             permission:"income-view",

        //             sub_menus: [
        //                 {
        //                     title: "Submit New Report",
        //                     url: "/forms/add/annual-report",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"income-create",
        //                 },
        //                 {
        //                     title: "View Submitted Reports",
        //                     url: "/forms/annual-report",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"income-view",
        //                 }
        //             ]
        //         },
        //         {
        //             title: "FRM EC16D (Income)",
        //             url: "income",
        //             icon: null,
        //             has_sub_menu: true,
        //             open: false,
        //             permission:"income-view",

        //             sub_menus: [
        //                 {
        //                     title: "Submit New Report",
        //                     url: "/forms/home/reporting",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"income-create",
        //                 },
        //                 {
        //                     title: "View Submitted Reports",
        //                     url: "/forms/reporting",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"income-view",
        //                 }
        //             ]
        //         },
        //         {
        //             title: "FRM EC16E (Expenditure)",
        //             url: "expenditures",
        //             icon: null,
        //             has_sub_menu: true,
        //             open: false,
        //             permission:"expenses-view",

        //             sub_menus: [
        //                 {
        //                     title: "Submit New Report",
        //                     url: "/forms/home/expenditures",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"expenses-create",
        //                 },
        //                 {
        //                     title: "View Submitted Reports",
        //                     url: "/forms/expenditures",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"expenses-view",
        //                 }
        //             ]
        //         },
        //         {
        //             title: "FRM EC16F (Tracking)",
        //             url: "tracking",
        //             icon: null,
        //             has_sub_menu: true,
        //             open: false,
        //             permission:"tracking-view",

        //             sub_menus: [
        //                 {
        //                     title: "Submit New Report",
        //                     url: "/forms/add/tracking",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"tracking-create",
        //                 },
        //                 {
        //                     title: "View Submitted",
        //                     url: "/forms/tracking",
        //                     icon: null,
        //                     has_sub_menu: false,
        //                     permission:"tracking-view",
        //                 }
        //             ]
        //         },
        //     ]
        // },

        {
            title: "Annual Report",
            url: "annual",
            icon: "icon-bar-chart-2",
            has_sub_menu: true,
            open: false,
            permission:"income-view",

            sub_menus: [
                {
                    title: "Submit New Report",
                    url: "/forms/add/annual-report",
                    icon: null,
                    has_sub_menu: false,
                    permission:"income-create",
                },
                {
                    title: "View Submitted Reports",
                    url: "/forms/annual-report",
                    icon: null,
                    has_sub_menu: false,
                    permission:"income-view",
                }
            ]
        },
        {
            title: "Income Report",
            url: "income",
            icon: "icon-briefcase",
            has_sub_menu: true,
            open: false,
            permission:"income-view",

            sub_menus: [
                {
                    title: "Submit New Report",
                    url: "/forms/home/reporting",
                    icon: null,
                    has_sub_menu: false,
                    permission:"income-create",
                },
                {
                    title: "View Submitted Reports",
                    url: "/forms/reporting",
                    icon: null,
                    has_sub_menu: false,
                    permission:"income-view",
                }
            ]
        },
        {
            title: "Expenditure Report",
            url: "expenditures",
            icon: "icon-credit-card",
            has_sub_menu: true,
            open: false,
            permission:"expenses-view",

            sub_menus: [
                {
                    title: "Submit New Report",
                    url: "/forms/home/expenditures",
                    icon: null,
                    has_sub_menu: false,
                    permission:"expenses-create",
                },
                {
                    title: "View Submitted Reports",
                    url: "/forms/expenditures",
                    icon: null,
                    has_sub_menu: false,
                    permission:"expenses-view",
                }
            ]
        },
        {
            title: "Campaign Tracking",
            url: "tracking",
            icon: "icon-bar-chart",
            has_sub_menu: true,
            open: false,
            permission:"tracking-view",

            sub_menus: [
                {
                    title: "Submit New Report",
                    url: "/forms/add/tracking",
                    icon: null,
                    has_sub_menu: false,
                    permission:"tracking-create",
                },
                {
                    title: "View Submitted",
                    url: "/forms/tracking",
                    icon: null,
                    has_sub_menu: false,
                    permission:"tracking-view",
                }
            ]
        },

        {
            title: "Income Vs Expenses",
            url: "/reports/income-expenses",
            icon: "icon-life-buoy",
            has_sub_menu: false,
            permission:"income-expenses-report-view"
        },
        
        {
            title: "Analytics",
            url: "/analytics/tracking",
            icon: "icon-book",
            has_sub_menu: false,
            // open: false,
            permission:"analytics-view",

            sub_menus: [
                // {
                //     title: "FORM EC16D",
                //     url: "/",
                //     icon: null,
                //     has_sub_menu: false,
                // },
                // {
                //     title: "FORM EC16E",
                //     url: "/analytics/advertExpenses",
                //     icon: null,
                //     has_sub_menu: false,
                // },
                {
                    title: "Report Analysis",
                    url: "/analytics/tracking",
                    icon: null,
                    has_sub_menu: false,
                    permission:"analytics-view",
                },
            ]
        },
        {
            title: "Manage Users",
            url: "/settings/users",
            icon: "icon-users",
            has_sub_menu: false,
            permission:"party-nation-wide-access"
        },
        {
            title: "Access Codes",
            url: "/parties/access-codes",
            icon: "icon-lock",
            has_sub_menu: false,
            menu_title: "Parties Mgnt",
            permission:"party-registration-view"
        },
        {
            title: "Associations",
            url: "/parties/intending",
            icon: "icon-users",
            has_sub_menu: false,
            menu_title: "Parties Mgnt",
            permission:"party-registration-view"
        },
        {
            title: "Registered Parties", 
            url: "/parties/registered",
            icon: "icon-check-circle",
            has_sub_menu: false,
            permission:"party-registration-view"
        },
        
        {
            title: "Merged Parties",
            url: "/parties/merged",
            icon: "icon-anchor",
            has_sub_menu: false,
            permission:"party-registration-view"
        },
        {
            title: "De-Registered Parties",
            url: "/parties/deregistered",
            icon: "icon-trash",
            has_sub_menu: false,
            permission:"party-registration-view"
        },
        {
            title: "Settings",
            url: "settings",
            icon: "icon-lock",
            has_sub_menu: true,
            menu_title: "Settings",
            open: false,
            permission:"settings-view",

            sub_menus: [
                {
                    title: "System Users",
                    url: "/settings/users",
                    icon: null,
                    has_sub_menu: false,
                    permission:"users-view",
                },
                {
                    title: "Political Parties",
                    url: "/settings/parties",
                    icon: null,
                    has_sub_menu: false,
                    permission:"parties-view",
                },
                {
                    title: "Elective Positions",
                    url: "/settings/positions",
                    icon: null,
                    has_sub_menu: false,
                    permission:"positions-view",
                },
                {
                    title: "Media Channels",
                    url: "/settings/channels",
                    icon: null,
                    has_sub_menu: false,
                    permission:"media-view",
                },
                {
                    title: "Zones",
                    url: "/settings/zones",
                    icon: null,
                    has_sub_menu: false,
                    permission:"zones-view",
                },
                {
                    title: "States",
                    url: "/settings/states",
                    icon: null,
                    has_sub_menu: false,
                    permission:"states-view",
                },
                {
                    title: "Senatorial Zones",
                    url: "/settings/senatorial",
                    icon: null,
                    has_sub_menu: false,
                    permission:"zones-view",
                },
                {
                    title: "Federal Constituencies",
                    url: "/settings/constituencies",
                    icon: null,
                    has_sub_menu: false,
                    permission:"constituencies-view",
                },
                {
                    title: "State Constituencies",
                    url: "/settings/state-constituencies",
                    icon: null,
                    has_sub_menu: false,
                    permission:"constituencies-view",
                },
                {
                    title: "Report Submission",
                    url: "/settings/report-submission",
                    icon: null,
                    has_sub_menu: false,
                    permission:"report-submission-view",
                },
                {
                    title: "Supporting Documents",
                    url: "/settings/supporting-documents",
                    icon: null,
                    has_sub_menu: false,
                    permission:"supporting-document-view",
                },
                // {
                //     title: "L.G.A",
                //     url: "/settings/lgas",
                //     icon: null,
                //     has_sub_menu: false,
                // },
                
            ]
        },
        // {
        //     title: "Audit Trail",
        //     url: "/",
        //     icon: "icon-home",
        //     has_sub_menu: false,
        // },
        {
            title: "Gallery",
            url: "/gallery",
            icon: "icon-image",
            has_sub_menu: false,
            permission:"gallery-view"
        },
        {
            title: "Downloads",
            url: "/download-center",
            icon: "icon-sunset",
            has_sub_menu: false,
            permission:"downloads-view",
        },
        // {
        //     title: "Support",
        //     url: "/support",
        //     icon: "icon-sunset",
        //     has_sub_menu: false,
        //     permission:"roles",
        // },
        {
            title: "Log Out",
            url: "/logout",
            icon: "icon-lock",
            has_sub_menu: false,
            permission:"dashboard",
        },
];

